import {
  FILE_TYPE_AUDIO,
  FILE_TYPE_DOWNLOAD,
  FILE_TYPE_LINK,
  FILE_TYPE_PDF,
  FILE_TYPE_VIDEO
} from "@constants/FileType";

export const isVideoFile = (media: number) => FILE_TYPE_VIDEO.includes(media);
export const isAudioFile = (media: number) => FILE_TYPE_AUDIO.includes(media);
export const isPDFFile = (media: number) => FILE_TYPE_PDF.includes(media);
export const isLinkFile = (media: number) => FILE_TYPE_LINK.includes(media);
export const isDownloadFile = (media: number) => FILE_TYPE_DOWNLOAD.includes(media);